export class Features {

  private constructor() {
  }

  static ASKWYZE_ENABLED: boolean = true;
}